import React from "react";
import { useListingsContext } from "./ListingsContext";
import ProductGrid from "./ProductGrid";
import Box from "./Box";
import HeadingMedium from "./HeadingMedium";
import LatestDropSignup from "./LatestDropSignup";
import Spinner from "./Spinner";
import ProductPagination from "./ProductPagination";
import Signup from "./Signup";

const LOW_STOCK_THRESHOLD = 21;

function FilteredProducts({ brand, isLatestDrop }) {
  const { products, activeFilters, pageInfo, key, loadingProducts } =
    useListingsContext();

  if (!activeFilters) return <Spinner />;

  const hasNotAppliedFilters = activeFilters.length === 0;
  const isSoldOut = products.length == 0 && hasNotAppliedFilters;
  const hasLowStock =
    products.length > 0 &&
    products.length < LOW_STOCK_THRESHOLD &&
    hasNotAppliedFilters;
  const hasFilteredToNothing = products.length == 0 && !hasNotAppliedFilters;
  const isSoldOutOrLowStock =
    !pageInfo.hasPrevious && (isSoldOut || hasLowStock);
  const isLastPage = pageInfo && pageInfo.hasPrevious && !pageInfo.hasNext;

  return (
    <React.Fragment key={key}>
      {products.length > 0 && loadingProducts === false && (
        <ProductGrid
          products={products}
          desktopCols={4}
          mobCols={2}
          brand={brand}
          showCategoryButtons={isLatestDrop}
        />
      )}
      {loadingProducts && <Spinner />}
      {hasFilteredToNothing && loadingProducts === false && (
        <HeadingMedium uppercase>No items</HeadingMedium>
      )}
      <ProductPagination />
      {!loadingProducts && (isLastPage || isSoldOutOrLowStock) && (
        <Box mt={[50, null, 90, null]}>
          {isLatestDrop ? (
            <LatestDropSignup brand={brand} />
          ) : (
            <Signup
              brand={brand}
              heading="Join the movement"
              text="<b>Sign up to Reskinned</b> to find out more about what we do and be
      the first to find out when drops are happening from the brands
      you love."
              buttonText="Learn more"
            />
          )}
        </Box>
      )}
    </React.Fragment>
  );
}

export default FilteredProducts;
